const Cards = [
    {
        name: 'Ultimate',
        id: 'ULT931840',
        deepLinkKey: 'udl-cc-ultimate',
        productId: 931840,
    },

    {
        name: 'Low Rate',
        id: 'LOR931703',
        deepLinkKey: 'udl-cc-lowrate',
        productId: 4,
    },

    {
        name: 'Awards',
        id: 'AWA931707',
        deepLinkKey: 'udl-cc-awards',
        productId: 1,
    },

    {
        name: 'Smart Awards',
        id: 'SMA931857',
        deepLinkKey: 'udl-cc-smart',
        productId: 931857,
    },

    {
        name: 'Neo',
        id: 'NEO931847',
        deepLinkKey: 'udl-cc-neo',
        productId: 931847,
    },

    {
        name: 'Low Fee',
        id: 'LOF931715',
        deepLinkKey: 'udl-cc-lowfee',
        productId: 5,
    },

    {
        name: 'iflf',
        id: 'IFL931875',
        deepLinkKey: 'udl-cc-iflf',
        productId: 931875,
    },
];
export default Cards;
